module.exports = __webpack_public_path__ + "static/media/wrapper.9bfdff98.svg";